import React from 'react'
import { toast } from 'react-toastify'
import './styles.css'

type Props = {
    name: string
    label: string
    type: 'tel' | 'text' | 'date' | 'number' | 'email'
    value?: string
    note?: string
}
export const CopyInput: React.FC<Props> = ({
  name,
  label,
  type,
  value,
  note
}) => {
  const onClick = () => {
    window.navigator.clipboard.writeText(value)
    toast.success('Copied to clipboard')
  }

  return (
    <label htmlFor={name}>
      { label }
      <div className="copy-input">
        <input
          readOnly
          type={type}
          name={name}
          value={value}
          onClick={onClick}
        />
      </div>
      { !!note && (
        <sub>
          { note }
        </sub>
      )}
    </label>
  )
}

export const CopyTextArea: React.FC<Props> = ({
  name,
  label,
  value,
  note
}) => {
  const onClick = () => {
    window.navigator.clipboard.writeText(value)
    toast.success('Copied to clipboard')
  }

  return (
    <label htmlFor={name}>
      { label }
      <div className="copy-input">
        <textarea
          readOnly
          name={name}
          value={value}
          onClick={onClick}
        />
      </div>
      { !!note && (
        <sub>
          { note }
        </sub>
      )}
    </label>
  )
}
